/**
 * Define all available breakpoints here.
 *
 * If changed also update $breakpoints in /_common/sass/_project/_config.scss!
 *
 * @var {Object}
 *
 * @see S.mq()
 */
S.breakpoints = {
    mobilebig: 'only screen and (min-width: #{em(500px)})',
    tablet: 'only screen and (min-width: #{em(768px)})',
    desktop: 'print, only screen and (min-width: #{em(1024px)})',
    l: 'print, only screen and (min-width: #{em(1200px)})',
    ml: 'print, only screen and (min-width: #{em(1440px)})',
    xl: 'print, only screen and (min-width: #{em(1600px)})',
    xxl: 'print, only screen and (min-width: #{em(1840px)})', // 1840
    print: 'print',
};
